// Vap House: "Agregar" de los recomendados del cajón. Copia el flujo de product-form.js de Horizon:
// dispara CartLinesUpdateEvent con una promesa, agrega por /cart/add.js pidiendo las secciones del cajón,
// y resuelve con el carrito y las secciones para que Horizon re-dibuje cajón, contador y barra.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-vh-reco-add]');
  if (!btn || btn.getAttribute('aria-busy') === 'true') return;
  e.preventDefault();
  const id = btn.dataset.vhRecoAdd;
  if (!id) { console.error('vh-reco: variante sin id'); return; }
  btn.setAttribute('aria-busy', 'true');
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const fd = new FormData();
  fd.append('id', id); fd.append('quantity', '1');
  if (ids.length) fd.append('sections', [...new Set(ids)].join(','));
  const diferido = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: diferido.promise }));
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
    const res = await r.json();
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    diferido.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'vh-carrito-reco', sourceId: 'vh-reco-' + id, itemCount: 1,
                productId: btn.dataset.productId, sections: res.sections, didError: !!res.status },
    });
  } catch (err) {
    console.error('vh-reco', err);
    diferido.reject(err);
    btn.removeAttribute('aria-busy');
  }
});
